module.exports = __webpack_public_path__ + "media/images/identity_icono_3-8ddd0ae3.jpg";